import 'hammerjs';

/* Script for a playable deck */
export class Deck {
  constructor(element) {
    this.element = element;
    this.cards = document.querySelectorAll('.awk-card--question');
    this.cardCount = this.cards.length;
    this.current = parseInt(
      document.querySelector('.awk-card.current').dataset.position,
      10,
    );
    this.announce = document.querySelector('.awk-deck__announce');

    this.navigation = document.querySelectorAll('.awk-deck__arrow');
    this.nextButton = document.getElementById('next');
    this.prevButton = document.getElementById('prev');

    this.updateNavigation(this.current);
    this.initDraggable();
    this.initNavigationHandler();
    this.initDrawPileClickHandler();
    this.initShare();
    this.setAccessibleAttributes();

    this.isMobileFinished = false;
    this.updateAnnounce(this.current);
  }

  updateNavigation(position) {
    const allowMobileExtra = this.hasMobileExtra(position);

    if (position === 0) {
      this.prevButton.setAttribute('disabled', true);
    } else {
      this.prevButton.removeAttribute('disabled');
    }

    if (position >= this.cards.length && !allowMobileExtra) {
      this.nextButton.setAttribute('disabled', true);
    } else {
      this.nextButton.removeAttribute('disabled');
    }
  }

  updateAnnounce(position) {
    this.announce.innerText =
      position === 0
        ? `Intro Card. Deck has ${this.cardCount} cards.`
        : `Card ${position} out of ${this.cardCount}`;
  }

  setAccessibleAttributes() {
    document
      .querySelectorAll('.awk-card--question:not(.current)')
      .forEach((card) => {
        card.setAttribute('inert', true);
        card.setAttribute('aria-hidden', true);
      });
  }

  updateDeck(delta) {
    const current = document.querySelector('.awk-card.current');

    const currentPosition = parseInt(current.dataset.position, 10);
    const nextPosition = currentPosition + delta;
    const allowMobileExtra = this.hasMobileExtra(currentPosition);

    if ((delta === -1) & this.isMobileFinished) {
      document
        .querySelector('.awk-deck__draw-pile')
        .classList.remove('finished');
      this.isMobileFinished = false;
      return;
    }

    if (
      (nextPosition > this.cards.length && !allowMobileExtra) ||
      nextPosition < 0
    ) {
      return;
    }

    if (allowMobileExtra && delta === 1) {
      document.querySelector('.awk-deck__draw-pile').classList.add('finished');
      this.isMobileFinished = true;
      this.nextButton.setAttribute('disabled', true);

      return;
    }

    const nextCurrent = document.getElementById(`current-card-${nextPosition}`);

    if (delta > 0) {
      const drawCard = document.getElementById(`draw-card-${nextPosition}`);
      drawCard.classList.add('hidden');
      drawCard.setAttribute('inert', true);

      nextCurrent.classList.remove('hidden');
    } else {
      const drawCard = document.getElementById(`draw-card-${currentPosition}`);
      drawCard.classList.remove('hidden');
      drawCard.removeAttribute('inert');

      current.classList.add('hidden');

      nextCurrent.classList.remove('hidden');
    }

    current.classList.remove('current');

    nextCurrent.classList.add('current');
    nextCurrent.removeAttribute('inert');
    nextCurrent.removeAttribute('aria-hidden');

    this.setAccessibleAttributes();

    window.history.pushState({}, '', nextCurrent.dataset.permalink);

    this.updateNavigation(nextPosition);
    this.updateAnnounce(nextPosition);
  }

  initNavigationHandler() {
    /* Add Event Listener for Pagination */
    this.navigation.forEach((arrow) => {
      arrow.addEventListener('click', (event) => {
        const delta = parseInt(event.currentTarget.dataset.delta, 10);

        this.updateDeck(delta);
      });
    });
  }

  initShare() {
    /* Add Event Listener for Share Buttons */
    const handleShareClick = (event) => {
      const card = event.currentTarget.closest('.awk-card');
      const title = card
        .querySelector('.awk-card__deck-name')
        .textContent.trim();
      const text = card.querySelector('.awk-card__content').textContent.trim();

      navigator.share({
        title,
        text,
        url: card.dataset.permalink,
      });
    };

    document.querySelectorAll('.awk-card__share-button').forEach((button) => {
      button.addEventListener('click', handleShareClick);
    });
  }

  initDrawPileClickHandler() {
    document
      .querySelectorAll(
        '.awk-deck__draw-pile .awk-card:not(.awk-card--deck-outro)',
      )
      .forEach((card) => {
        card.addEventListener('click', () => {
          this.updateDeck(1);
        });
      });
  }

  initDraggable() {
    const hammer = new Hammer(document.querySelector('.awk-deck__piles'));

    hammer.on('swipeleft', (event) => {
      event.preventDefault = true;

      this.updateDeck(1);
    });

    hammer.on('swiperight', (event) => {
      event.preventDefault = true;

      this.updateDeck(-1);
    });
  }

  hasMobileExtra(position) {
    const isMobile = window.matchMedia('(max-width: 782px)').matches;
    return position === this.cards.length && isMobile;
  }
}
